import React, { useState, useEffect } from "react";
import { getMethod, ApiEndPoint, postMethod } from "services";
import { LocationPermission } from "common/interfaces";
import {
    Button, CircularProgress, Accordion, AccordionSummary, AccordionDetails, Checkbox, Grid, List, ListItem
} from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroll-component";
import "./delegates.scss";
import { useTranslation } from "react-i18next";
import { CheckAccess, claims, depotGoogleMap, GetUrlDetails, PERMISSION_TYPE, REPORT_PERMISSION_TYPE, setAddressFormat, urlReplace } from 'common';
import { useHistory } from "react-router-dom";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CommonGoogleMap from "components/commonGoogleMap";
import { toUpper } from "lodash";
import Images from "assets/images";
import { useDispatch } from "react-redux";
import { showErrorMessages } from "redux/actions/errorMessages";
import CommonEditLocationPermissionTable from "./commonEditLocationPermissionTable";
import ConfirmDialogPopupComponent from "components/confirmDialogPopupComponent";

const EditLocationPermissionListing = (props: LocationPermission) => {
    const dispatch = useDispatch();
    const [locationZonesList, setLocationZonesList] = useState<any>([]);
    const [locationSettingList, setLocationSettingList] = useState<any>([]);
    const [locationSettingsFiltered, setLocationSettingsFiltered] = useState<any>(null);
    const [currentPage, setCurrentPage] = useState(0);
    const { t } = useTranslation();
    const history = useHistory();
    const { delegateId } = GetUrlDetails(history, 'hostSettings');
    const [loadingPage, setLoadingPage] = useState(false);
    const [loadingSavePage, setLoadingSavePage] = useState(false);
    const [hasMore, setHasMore] = useState<boolean>(false);
    const PERMISSION_USAGERATE = CheckAccess([claims.PRICING_UPDATE]);
    const DEFAULT_PAGE_SIZE = 500;
    let isFleetSubscribed = false; //sessionStorage.getItem('fleetSubscribtion');
    const delegateAssignAll: any = [{id: 1,columnLabel: "common.selectlocationall", LabelFormat: false, columnVisible: true, classFormat: ''}];
    const delegateAssignCancelButtonAction = {isVisible: true, buttonName: 'common.cancelbutton', buttonPermssion: true, classFormat: ''};
    const delegateAssignSaveButtonAction = {isVisible: true, buttonName: 'common.ok', buttonPermssion: true, classFormat: 'blue_bg', disabled: false };
    const [delegateAssignAllOpen, setDelegateAssignAllOpen] = useState(false);
    const [eventChecked, setEventChecked] = useState(false);
    const [disableSelectAllRow, setDisableSelectAllRow] = useState(false);

    useEffect(() => {
        getSettingData();
    }, []);

    useEffect(() => {
        if (locationSettingsFiltered !== null) {
            getLocationDataPaginated(currentPage, DEFAULT_PAGE_SIZE);
        }
    }, [locationSettingsFiltered])


    useEffect(() => {
        if (currentPage > 0) {
            getLocationDataPaginated(currentPage, DEFAULT_PAGE_SIZE);
        }
    }, [locationSettingsFiltered, currentPage])

    const locationIndexValue = (locationList: any, locationId: any) => {
        return locationList?.findIndex(((loc: any) => loc?.locationDTO?.locationId === locationId));
    }

    const zoneIndexValue = (zoneList: any, zoneId: any) => {
        return zoneList?.findIndex((obj: any) => obj?.zoneDTO?.id === zoneId);
    }

    const setFinalLocationData = (locationData: any) => {
        return locationData.map((object: any, index: any) => {
            let locationAccess = object?.locationLevelPermissions ? true : false;
            let zonePermissionAccess = object?.zoneLevelPermissions?.filter((val: any) => val?.permissions)?.length > 0 ? true : false;
            let zoneLevelAccess = object?.zoneLevelPermissions?.map((obj: any) => {
                let zoneAccess = obj?.permissions ? true : false;
                return { ...obj, zoneAccess: zoneAccess };
            });
            return { ...object, locationAccess: locationAccess, zoneLevelPermissions: zoneLevelAccess, indexValue: index, zoneLevelAccess: zonePermissionAccess, };
        });
    }

    const getSettingData = async () => {
        setLoadingPage(true);
        const url = urlReplace(ApiEndPoint.locationSetting, "{DELEGATE-ID}", delegateId);
        let params = `?page=${0}&size=${500}`
        await getMethod(url, params, false)
            .then((res) => {
                if (res && res?.data && res?.data?.delegateLocationZonePermissionDTOS) {
                    const finalLocationData = setFinalLocationData(res?.data?.delegateLocationZonePermissionDTOS);
                    setLocationSettingsFiltered(finalLocationData);
                } else {
                    setLocationSettingsFiltered([]);
                }
            })
            .catch((err) => {
                setLoadingPage(false);
                console.error("Error", err);
            });
        setLoadingPage(false);
    };

    const getLocationDataPaginated = async (currentPage: number = 0, pageSize: number = 10) => {
        let params = `?page=${currentPage}&size=${pageSize}`
        await getMethod(ApiEndPoint.allLocationZones, params, false)
            .then((res) => {
                if (res && res?.data && res?.data?.locationZonesDetailDTOS?.length > 0) {
                    const locationZonesListLen = locationZonesList?.length;
                    const newLocationZoneList = locationZonesList;
                    newLocationZoneList.push(...res.data.locationZonesDetailDTOS);
                    setHasMore(res?.data?.totalLocations > (currentPage + 1) * pageSize);
                    let currentPagelocationZonesData: Array<any> = [];
                    currentPagelocationZonesData = res?.data?.locationZonesDetailDTOS?.map((val: any, index: any) => {
                        let assignedListIndex = locationIndexValue(locationSettingsFiltered, val.locationId);
                        let nextLocationIndex = locationZonesListLen + index;
                        let isLocationPermitted = assignedListIndex >= 0 ? true : false;
                        let zonePermissionAccess = locationSettingsFiltered[assignedListIndex]?.zoneLevelPermissions?.filter((val: any) => val?.zoneAccess === true)?.length > 0 ? true : false;
                        let zoneLevelAccess = val?.zones?.map((obj: any) => {
                            let zoneIndex = zoneIndexValue(locationSettingsFiltered[assignedListIndex]?.zoneLevelPermissions, obj?.id);
                            let isZoneIndex = zoneIndex >= 0 ? true : false;
                            return {
                                zoneDTO: obj,
                                permissions: isZoneIndex ? locationSettingsFiltered[assignedListIndex]?.zoneLevelPermissions[zoneIndex]?.permissions : null,
                                reportPermissions: isZoneIndex ? locationSettingsFiltered[assignedListIndex]?.zoneLevelPermissions[zoneIndex]?.reportPermissions : null,
                                zoneAccess: isZoneIndex ? locationSettingsFiltered[assignedListIndex]?.zoneLevelPermissions[zoneIndex]?.zoneAccess : false
                            };
                        })
                        const locationObj = {
                            indexValue: nextLocationIndex,
                            zoneLevelAccess: zonePermissionAccess,
                            locationAccess: isLocationPermitted ? locationSettingsFiltered[assignedListIndex]?.locationAccess : null,
                            locationDTO: val,
                            locationLevelPermissions: isLocationPermitted ? locationSettingsFiltered[assignedListIndex]?.locationLevelPermissions : null,
                            zoneLevelPermissions: zoneLevelAccess,
                            locationLevelReportPermissions: isLocationPermitted ? locationSettingsFiltered[assignedListIndex]?.locationLevelReportPermissions : null
                        }
                        return locationObj;
                    });

                    const allLocationZonesData: Array<any> = [...locationSettingList, ...currentPagelocationZonesData];
                    setLocationSettingList(allLocationZonesData);
                    setLocationZonesList(newLocationZoneList);
                } else {
                    setHasMore(false);
                    setLocationSettingList(locationSettingsFiltered);
                }
            })
            .catch((err) => {
                setLoadingPage(false);
                console.error("Error", err);
            });
        setLoadingPage(false);
    };

    const loadMoreItems = () => {
        setCurrentPage(currentPage + 1)
    };

    const handleDefaultSelectAll = (val:any, permission?:any, permissionLevel?:any, reportPermission?:any) => {
        let selectAllCheck = false;
        let locationList = [...locationSettingList];
        if (reportPermission) {
            selectAllCheck = locationList?.every((value:any) => {
                return Object.values(REPORT_PERMISSION_TYPE).every(key =>
                    {
                        if (key === REPORT_PERMISSION_TYPE.FLEET_REPORT) return true;
                        return value?.locationLevelReportPermissions?.includes(key)
                    }
                );
            });
        } else if(permission) {
            selectAllCheck = locationList?.every((value) => handlePermissionStatus(value?.[permissionLevel],val) === true);
        } else {
            selectAllCheck = locationList?.every((value) => value[val] === true);
            setDisableSelectAllRow(!selectAllCheck);
        }
        return selectAllCheck;
    }

    const handleCheckBoxColor = () => {
        let checkBoxColor = false;
        checkBoxColor = disableSelectAllRow;                 
        return checkBoxColor ? 'secondary' : 'primary';
    }
    
    const manageSelectAll = (e: any, permissionType: any, report?: any) => {
        let locationList = [...locationSettingList];
        locationList?.map((value: any) => {
            if (permissionType === PERMISSION_TYPE.LOCATION) {                
                if (e.target.checked === false) {
                    setEventChecked(false);            
                } else {     
                    setEventChecked(true);                     
                }
                setDelegateAssignAllOpen(true);
            } else if (report) {
                getPermissionsForReports(value, e);
            } else {
                let locationPermission = e.target.checked ? getLocationPermission(value, permissionType) : value.locationLevelPermissions?.filter((val: any) => val !== permissionType);
                value.locationLevelPermissions = locationPermission;
            }
        })
        if (permissionType !== PERMISSION_TYPE.LOCATION)
            setLocationSettingList(locationList);
    }

    const getPermissionsForReports = (value: any, e: any) => {
        Object.values(REPORT_PERMISSION_TYPE).forEach((permission: any) => {
            let reportPermissionTypes = {};
            if (permission === REPORT_PERMISSION_TYPE.FLEET_REPORT && !isFleetSubscribed) return;
            reportPermissionTypes = value.locationLevelReportPermissions ? value.locationLevelReportPermissions?.concat(permission) : [permission];
            let locationReportPermission = e.target.checked ? reportPermissionTypes : [];
            value.locationLevelReportPermissions = locationReportPermission;
        })
    }

    const getLocationPermission = (value?: any, permissionType?: any) => {
        return value.locationLevelPermissions ? value.locationLevelPermissions?.concat(permissionType) : [permissionType];
    }

    const setPermissionAfterConfirmation = () => {
        let locationList = [...locationSettingList];
        locationList?.map((value: any) => {
            value.locationAccess = eventChecked;
            if (eventChecked) {                
                value.zoneLevelAccess = false;
                value?.zoneLevelPermissions?.map((zoneValue: any) => {
                    zoneValue.zoneAccess = false;
                    zoneValue.permissions = [];
                    zoneValue.reportPermissions = [];
                })
            } else {
                value.locationLevelPermissions = [];
                value.locationLevelReportPermissions = [];
            }
        })
        setDelegateAssignAllOpen(false);
        setLocationSettingList(locationList);
    }

    const onChangeLocationPermission = (e: any, locationId: any, permissionType: any, report?: any) => {
        let locationList = [...locationSettingList];
        let objIndex = locationIndexValue(locationList, locationId);
        if (permissionType === PERMISSION_TYPE.LOCATION) {
            locationList[objIndex].locationAccess = e.target.checked;
            if (e.target.checked === false) {
                locationList[objIndex].locationLevelPermissions = [];
                locationList[objIndex].locationLevelReportPermissions = [];
            }
        } else if (report) {
            let reportPermissionTypes = (locationList[objIndex].locationLevelReportPermissions ? locationList[objIndex].locationLevelReportPermissions?.concat(permissionType) : [permissionType]);
            let locationReportPermission = e.target.checked ? reportPermissionTypes : locationList[objIndex].locationLevelReportPermissions?.filter((val: any) => val !== permissionType);
            locationList[objIndex].locationLevelReportPermissions = locationReportPermission;
        } else {
            let permissionTypes = (locationList[objIndex].locationLevelPermissions ? locationList[objIndex].locationLevelPermissions?.concat(permissionType) : [permissionType]);
            let locationPermission = e.target.checked ? permissionTypes : locationList[objIndex].locationLevelPermissions?.filter((val: any) => val !== permissionType);
            locationList[objIndex].locationLevelPermissions = locationPermission;
        }
        setLocationSettingList(locationList);
    };

    const onChangeZonePermission = (e: any, locationId: any, zoneId: any, permissionType: any, report?: any) => {
        let locationList = [...locationSettingList];
        let objIndex = locationIndexValue(locationList, locationId);
        let zoneIndex = zoneIndexValue(locationList[objIndex].zoneLevelPermissions, zoneId);
        let zoneLevelAccess = (locationList[objIndex]?.zoneLevelPermissions?.filter((val: any) => val?.zoneAccess === true)?.length <= 1 && e.target.checked === false) ? false : true;
        if (permissionType === PERMISSION_TYPE.ZONE) {
            locationList[objIndex].zoneLevelPermissions[zoneIndex].zoneAccess = e.target.checked;
            if (e.target.checked === false) {
                locationList[objIndex].zoneLevelPermissions[zoneIndex].permissions = [];
                locationList[objIndex].zoneLevelPermissions[zoneIndex].reportPermissions = [];
            }
            locationList[objIndex].zoneLevelAccess = zoneLevelAccess;
        } else if(report) {
            let zoneLevelReportPermissionTypes = (locationList[objIndex].zoneLevelPermissions[zoneIndex].reportPermissions ? locationList[objIndex].zoneLevelPermissions[zoneIndex].reportPermissions?.concat(permissionType) : [permissionType]);
            let zoneLevelReportPermission = e.target.checked ? zoneLevelReportPermissionTypes : locationList[objIndex].zoneLevelPermissions[zoneIndex].reportPermissions?.filter((val: any) => val !== permissionType);
            locationList[objIndex].zoneLevelPermissions[zoneIndex].reportPermissions = zoneLevelReportPermission;
            let zonePermissions = (locationList[objIndex].zoneLevelPermissions[zoneIndex].permissions) ? (locationList[objIndex].zoneLevelPermissions[zoneIndex].permissions) : [];
            locationList[objIndex].zoneLevelPermissions[zoneIndex].permissions = zonePermissions;
        } else {
            let permissionTypes = (locationList[objIndex].zoneLevelPermissions[zoneIndex].permissions ? locationList[objIndex].zoneLevelPermissions[zoneIndex].permissions?.concat(permissionType) : [permissionType]);
            let zonePermission = e.target.checked ? permissionTypes : locationList[objIndex].zoneLevelPermissions[zoneIndex].permissions?.filter((val: any) => val !== permissionType);
            locationList[objIndex].zoneLevelPermissions[zoneIndex].permissions = zonePermission;
            let zoneReportPermissions = (locationList[objIndex].zoneLevelPermissions[zoneIndex].reportPermissions) ? (locationList[objIndex].zoneLevelPermissions[zoneIndex].reportPermissions) : [];
            locationList[objIndex].zoneLevelPermissions[zoneIndex].reportPermissions = zoneReportPermissions;
            locationList[objIndex].zoneLevelAccess = zoneLevelAccess;
        }
        setLocationSettingList(locationList);
    };

    const handlePermissionStatus = (permissionData: any, permissionType: any) => {
        let permissionAccess = false;
        let permissionMatched = permissionData?.find((type: any) => type === permissionType);
        if (permissionMatched) {
            permissionAccess = true;
        }
        return permissionAccess;
    };

    const setDelegateAssignAllClose = () => {
        setDelegateAssignAllOpen(false);
    }

    const saveChanges = () => {
        setLoadingSavePage(true);
        const url = urlReplace(ApiEndPoint.locationSetting, "{DELEGATE-ID}", delegateId);
        const finalLocation = locationSettingList?.map((object: any) => {
            let zoneLevelAccess = object?.zoneLevelPermissions?.filter((val: any) =>
                (val?.permissions?.length > 0 || val?.reportPermissions?.length > 0)
            ).map((obj: any) => {
                return {
                    zoneId: obj.zoneDTO.id,
                    permissions: obj.permissions,
                    reportPermissions: obj.reportPermissions
                };
            })
            return { locationId: object?.locationDTO?.locationId, locationLevelPermissions: object?.locationLevelPermissions?.length > 0 ? object?.locationLevelPermissions : null, zoneLevelPermissions: zoneLevelAccess?.length > 0 ? zoneLevelAccess : null, locationLevelReportPermissions: object?.locationLevelReportPermissions?.length > 0 ? object?.locationLevelReportPermissions : null };
        }).filter((value: any) => (value?.locationLevelPermissions?.length > 0 || value?.zoneLevelPermissions?.length > 0 || value?.locationLevelReportPermissions?.length > 0))
        if (finalLocation) {
            postMethod(url, '', finalLocation)
                .then((res) => {
                    if (res.status === 200) {
                        props?.editlocationPermissionClose();
                    } else {
                        dispatch(showErrorMessages({ error: true, message: "common.something.went.wrong.errmsg", type: "error", operation: "" }));
                        props?.editlocationPermissionClose();
                    }
                    setLoadingSavePage(false);
                })
                .catch((err) => {
                    setLoadingSavePage(false);
                    dispatch(showErrorMessages({ error: true, message: "common.something.went.wrong.errmsg", type: "error", operation: "" }));
                    console.error("Error", err);
                });
        }
    };

    return (
        <>
            <div className="dialog_box" data-testid="select_all_delegate">
                <ConfirmDialogPopupComponent
                    popUpPageOpen={delegateAssignAllOpen}
                    popUpPageClose={setDelegateAssignAllClose}
                    headerName={"common.confirmselectall"}
                    fieldDetails={delegateAssignAll}
                    submitAction={delegateAssignSaveButtonAction}
                    cancelAction={delegateAssignCancelButtonAction }
                    submitData={setPermissionAfterConfirmation}
                />
            </div>
            <div data-testid="edit_location_permission_listing">
                <div className="information_section delegates_details mt-0">
                    <div className="button_row  full_right">

                        <Button className="btn_white" onClick={props?.editlocationPermissionClose}>{t("common.cancelbutton")}</Button>
                        <Button
                            className="btn_white blue_bg"
                            onClick={saveChanges}
                        >
                            {t("hostsetting.savepermission")}
                        </Button>
                    </div>
                </div>
                {locationSettingList.length > 0 &&
                    <CommonEditLocationPermissionTable
                        handleDefaultSelectAll={handleDefaultSelectAll}
                        permission_usageRate={PERMISSION_USAGERATE}
                        handleCheckBoxColor={handleCheckBoxColor}
                        disableSelectAllRow={disableSelectAllRow}
                        manageSelectAll={manageSelectAll}
                    />
                }
                <div className="accordian_table">
                    <div className="section_title mb">
                        {loadingSavePage === true && <CircularProgress className="inner_progress save_data" />}
                        <Grid container spacing={0}>
                            <Grid item xs={2}>
                                <h2 className="text-gapping">{toUpper(t("hostsetting.assign"))}</h2>
                            </Grid>
                            <Grid item xs={3}>
                                <h2 className="text-left">{toUpper(t("common.location"))}</h2>
                            </Grid>
                            <Grid
                                item
                                xs={2}
                            >
                                <h2>{toUpper(t("common.location.information"))}</h2>
                            </Grid>
                            {PERMISSION_USAGERATE &&
                                <Grid
                                    item
                                    xs={1}
                                >
                                    <h2>{toUpper(t("common.usagerate"))}</h2>
                                </Grid>}
                            <Grid
                                item
                                xs={1}
                            >
                                <h2>{toUpper(t("delegate.permission.fleet"))}</h2>
                            </Grid>
                            <Grid
                                item
                                xs={1}
                            >
                                <h2>{toUpper(t("delegate.permission.lcd"))}</h2>
                            </Grid>
                            <Grid
                                item
                                xs={1}
                            >
                                <h2>{toUpper(t("common.report"))}</h2>
                            </Grid>
                        </Grid>
                    </div>
                    {loadingPage === true &&
                        <CircularProgress className="inner_progress" />
                    }
                    <InfiniteScroll
                        dataLength={locationSettingList ? locationSettingList.length : 0}
                        next={loadMoreItems}
                        hasMore={hasMore}
                        loader={<CircularProgress className="inner_progress" />}
                        scrollableTarget="information_section"
                        className=""
                        style={{ overflowY: "hidden" }}
                    >
                        {locationSettingList?.map((value: any) => (

                            <Accordion className="" key={value?.locationDTO?.locationId}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <div className="section_group" onClick={(event) => event.stopPropagation()}>
                                        <Grid container spacing={0}>
                                            <Grid item xs={2}>
                                                <div className="defult_form accordian_check">
                                                    <div className="form_col checkbox text-gapping">
                                                        <Checkbox
                                                            id={value?.locationDTO?.locationId}
                                                            checked={value?.locationAccess}
                                                            color={value?.zoneLevelAccess ? 'secondary' : 'primary'}
                                                            disabled={value?.zoneLevelAccess}
                                                            onChange={(e: any) => onChangeLocationPermission(e, value?.locationDTO?.locationId, PERMISSION_TYPE.LOCATION)}
                                                        />

                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <div className="depot_details">
                                                    <div className="depot_information">

                                                        <div className="depot_location_map">
                                                            <CommonGoogleMap
                                                                center={{
                                                                    lat: value?.locationDTO?.address?.latitude,
                                                                    lon: value?.locationDTO?.address?.longitude,
                                                                }}
                                                                zoom={
                                                                    depotGoogleMap.zoom
                                                                }
                                                                markers={[
                                                                    {
                                                                        lat: value?.locationDTO?.address?.latitude,
                                                                        lon: value?.locationDTO?.address?.longitude,
                                                                    },
                                                                ]}
                                                            />
                                                        </div>
                                                        <div className="depot_info">
                                                            <div className="depot_name">{value?.locationDTO?.locationName}</div>

                                                            <div className="depot_addr">{setAddressFormat(value?.locationDTO?.address)}</div>
                                                            <div className="port_details">
                                                                <span className="port portDetailsEVSE"><img src={Images.IC_PORT_12x14} />
                                                                    {value?.locationDTO?.chargingStations} {t("common.station", { count: value?.locationDTO?.chargingStations })}{", "}
                                                                    {value?.locationDTO?.totalPorts} {t("common.port", { count: value?.locationDTO?.totalPorts })} </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={2}
                                            >
                                                <div className="defult_form accordian_check">
                                                    <div className="form_col checkbox">
                                                        <Checkbox
                                                            id={value?.locationDTO?.locationId}
                                                            checked={handlePermissionStatus(value?.locationLevelPermissions, PERMISSION_TYPE.LOCATION_INFO)}
                                                            disabled={!value?.locationAccess}
                                                            color={value?.locationAccess ? 'primary' : 'secondary'}
                                                            onChange={(e: any) => onChangeLocationPermission(e, value?.locationDTO?.locationId, PERMISSION_TYPE.LOCATION_INFO)}
                                                        />
                                                    </div>
                                                </div>
                                            </Grid>
                                            {PERMISSION_USAGERATE &&
                                                <Grid
                                                    item
                                                    xs={1}
                                                >
                                                    <div className="defult_form accordian_check">
                                                        <div className="form_col checkbox">
                                                            <Checkbox
                                                                id={value?.locationDTO?.locationId}
                                                                checked={handlePermissionStatus(value?.locationLevelPermissions, PERMISSION_TYPE.USAGE_RATE)}
                                                                disabled={!value?.locationAccess}
                                                                color={value?.locationAccess ? 'primary' : 'secondary'}
                                                                onChange={(e: any) => onChangeLocationPermission(e, value?.locationDTO?.locationId, PERMISSION_TYPE.USAGE_RATE)}
                                                            />
                                                        </div>
                                                    </div>
                                                </Grid>
                                            }
                                            <Grid
                                                item
                                                xs={1}
                                            >
                                                <div className="defult_form accordian_check">
                                                    <div className="form_col checkbox">
                                                        <Checkbox
                                                            id={value?.locationDTO?.locationId}
                                                            checked={handlePermissionStatus(value?.locationLevelPermissions, PERMISSION_TYPE.MANAGE_FLEET)}
                                                            disabled={!value?.locationAccess}
                                                            color={value?.locationAccess ? 'primary' : 'secondary'}
                                                            onChange={(e: any) => onChangeLocationPermission(e, value?.locationDTO?.locationId, PERMISSION_TYPE.MANAGE_FLEET)}
                                                        />
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={1}
                                            >
                                                <div className="defult_form accordian_check">
                                                    <div className="form_col checkbox">
                                                        <Checkbox
                                                            id={value?.locationDTO?.locationId}
                                                            checked={handlePermissionStatus(value?.locationLevelPermissions, PERMISSION_TYPE.LCD_DISPLAY)}
                                                            disabled={!value?.locationAccess}
                                                            color={value?.locationAccess ? 'primary' : 'secondary'}
                                                            onChange={(e: any) => onChangeLocationPermission(e, value?.locationDTO?.locationId, PERMISSION_TYPE.LCD_DISPLAY)}
                                                        />
                                                    </div>
                                                </div>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={2}
                                            >
                                                <List className='accordian_listing inner'>
                                                    <ListItem>
                                                        <div className="defult_form accordian_check">
                                                            <div className="form_col checkbox">
                                                                <label>
                                                                    <Checkbox
                                                                        id={value?.locationDTO?.locationId}
                                                                        checked={handlePermissionStatus(value?.locationLevelReportPermissions, REPORT_PERMISSION_TYPE.SUSTAINABILITY)}
                                                                        disabled={!value?.locationAccess}
                                                                        color={value?.locationAccess ? 'primary' : 'secondary'}
                                                                        onChange={(e: any) => onChangeLocationPermission(e, value?.locationDTO?.locationId, REPORT_PERMISSION_TYPE.SUSTAINABILITY, true)}
                                                                    />
                                                                    {t("report.sustainability")}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </ListItem>
                                                    <ListItem>
                                                        <div className="defult_form accordian_check">
                                                            <div className="form_col checkbox">
                                                                <label>
                                                                    <Checkbox
                                                                        id={value?.locationDTO?.locationId}
                                                                        checked={handlePermissionStatus(value?.locationLevelReportPermissions, REPORT_PERMISSION_TYPE.HOST_REVENUE)}
                                                                        disabled={!value?.locationAccess}
                                                                        color={value?.locationAccess ? 'primary' : 'secondary'}
                                                                        onChange={(e: any) => onChangeLocationPermission(e, value?.locationDTO?.locationId, REPORT_PERMISSION_TYPE.HOST_REVENUE, true)}
                                                                    />
                                                                    {t("report.hostrevenue")}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </ListItem>
                                                    <ListItem>
                                                        <div className="defult_form accordian_check">
                                                            <div className="form_col checkbox">
                                                                <label>
                                                                    <Checkbox
                                                                        id={value?.locationDTO?.locationId}
                                                                        checked={handlePermissionStatus(value?.locationLevelReportPermissions, REPORT_PERMISSION_TYPE.STATION_USAGE)}
                                                                        disabled={!value?.locationAccess}
                                                                        color={value?.locationAccess ? 'primary' : 'secondary'}
                                                                        onChange={(e: any) => onChangeLocationPermission(e, value?.locationDTO?.locationId, REPORT_PERMISSION_TYPE.STATION_USAGE, true)}
                                                                    />
                                                                    {t("report.stationusage")}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </ListItem>
                                                    <ListItem>
                                                        <div className="defult_form accordian_check">
                                                            <div className="form_col checkbox">
                                                                <label>
                                                                    <Checkbox
                                                                        id={value?.locationDTO?.locationId}
                                                                        checked={handlePermissionStatus(value?.locationLevelReportPermissions, REPORT_PERMISSION_TYPE.CHARGING_SESSIONS)}
                                                                        disabled={!value?.locationAccess}
                                                                        color={value?.locationAccess ? 'primary' : 'secondary'}
                                                                        onChange={(e: any) => onChangeLocationPermission(e, value?.locationDTO?.locationId, REPORT_PERMISSION_TYPE.CHARGING_SESSIONS, true)}
                                                                    />
                                                                    {t("report.chargingsessions")}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </ListItem>
                                                    {isFleetSubscribed &&
                                                        <ListItem>
                                                            <div className="defult_form accordian_check">
                                                                <div className="form_col checkbox">
                                                                    <label>
                                                                        <Checkbox
                                                                            id={value?.locationDTO?.locationId}
                                                                            checked={handlePermissionStatus(value?.locationLevelReportPermissions, REPORT_PERMISSION_TYPE.FLEET_REPORT)}
                                                                            disabled={!value?.locationAccess}
                                                                            color={value?.locationAccess ? 'primary' : 'secondary'}
                                                                            onChange={(e: any) => onChangeLocationPermission(e, value?.locationDTO?.locationId, REPORT_PERMISSION_TYPE.FLEET_REPORT, true)}
                                                                        />
                                                                        {t("report.fleet")}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </ListItem>
                                                    }
                                                </List>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails className="inner_summary">
                                    <div className="section_title">
                                        <Grid container spacing={0}>
                                            <Grid item xs={2}>
                                                <h2 className="text-gapping">{toUpper(t("common.assignzonepermission"))}</h2>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <h2 className="">{toUpper(t("common.zonename"))}</h2>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={2}
                                            >
                                                <h2>{toUpper(t("common.location.information"))}</h2>
                                            </Grid>
                                            {PERMISSION_USAGERATE &&
                                                <Grid
                                                    item
                                                    xs={1}
                                                >
                                                    <h2>{toUpper(t("common.usagerate"))}</h2>
                                                </Grid>}
                                            <Grid
                                                item
                                                xs={1}
                                            >
                                                <h2>{toUpper(t("delegate.permission.fleet"))}</h2>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={1}
                                            >
                                                <h2>{toUpper(t("delegate.permission.lcd"))}</h2>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={1}
                                            >
                                                <h2>{toUpper(t("common.report"))}</h2>
                                            </Grid>

                                            {!value?.zoneLevelPermissions &&
                                                <Grid item xs={12}><h2 className="no-row">{t("common.nozone")}</h2></Grid>
                                            }
                                        </Grid>
                                    </div>
                                    {value?.zoneLevelPermissions && value?.zoneLevelPermissions?.map((zoneData: any) => (
                                        <div className="section_group location_setting" onClick={(event) => event.stopPropagation()} key={zoneData?.zoneDTO?.id}>
                                            <Grid container spacing={0}>
                                                <Grid item xs={2}>
                                                    <div className="defult_form accordian_check">
                                                        <div className="form_col checkbox text-gapping">
                                                            <Checkbox
                                                                id={zoneData?.zoneDTO?.id}
                                                                disabled={value?.locationAccess}
                                                                checked={zoneData?.zoneAccess}
                                                                color={value?.locationAccess ? 'secondary' : 'primary'}
                                                                onChange={(e: any) => onChangeZonePermission(e, value?.locationDTO?.locationId, zoneData?.zoneDTO?.id, PERMISSION_TYPE.ZONE)
                                                                } />
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <div className="lctnname">{zoneData?.zoneDTO?.name}</div>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={2}
                                                >
                                                    <div className="defult_form accordian_check">
                                                        <div className="form_col checkbox">
                                                            <Checkbox
                                                                id={zoneData?.zoneDTO?.id}
                                                                checked={handlePermissionStatus(zoneData?.permissions, PERMISSION_TYPE.LOCATION_INFO)}
                                                                disabled={!zoneData?.zoneAccess}
                                                                color={zoneData?.zoneAccess ? 'primary' : 'secondary'}
                                                                onChange={(e: any) => onChangeZonePermission(e, value?.locationDTO?.locationId, zoneData?.zoneDTO?.id, PERMISSION_TYPE.LOCATION_INFO)
                                                                } />
                                                        </div>
                                                    </div>
                                                </Grid>
                                                {PERMISSION_USAGERATE &&
                                                    <Grid
                                                        item
                                                        xs={1}
                                                    >
                                                        <div className="defult_form accordian_check">
                                                            <div className="form_col checkbox">
                                                                <Checkbox disabled />
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                }
                                                <Grid
                                                    item
                                                    xs={1}
                                                >
                                                    <div className="defult_form accordian_check">
                                                        <div className="form_col checkbox">
                                                            <Checkbox
                                                                id={zoneData?.zoneDTO?.id}
                                                                checked={handlePermissionStatus(zoneData?.permissions, PERMISSION_TYPE.MANAGE_FLEET)}
                                                                disabled={!zoneData?.zoneAccess}
                                                                color={zoneData?.zoneAccess ? 'primary' : 'secondary'}
                                                                onChange={(e: any) => onChangeZonePermission(e, value?.locationDTO?.locationId, zoneData?.zoneDTO?.id, PERMISSION_TYPE.MANAGE_FLEET)
                                                                } />
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={1}
                                                >
                                                    <div className="defult_form accordian_check">
                                                        <div className="form_col checkbox ">
                                                            <Checkbox
                                                                id={zoneData?.zoneDTO?.id}
                                                                checked={handlePermissionStatus(zoneData?.permissions, PERMISSION_TYPE.LCD_DISPLAY)}
                                                                disabled={!zoneData?.zoneAccess}
                                                                color={zoneData?.zoneAccess ? 'primary' : 'secondary'}
                                                                onChange={(e: any) => onChangeZonePermission(e, value?.locationDTO?.locationId, zoneData?.zoneDTO?.id, PERMISSION_TYPE.LCD_DISPLAY)
                                                                } />
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={2}
                                                >
                                                    <List className='accordian_listing inner'>
                                                        <ListItem>
                                                            <div className="defult_form accordian_check">
                                                                <div className="form_col checkbox">
                                                                    <label>
                                                                        <Checkbox
                                                                            id={zoneData?.zoneDTO?.id}
                                                                            checked={handlePermissionStatus(zoneData?.reportPermissions, REPORT_PERMISSION_TYPE.SUSTAINABILITY)}
                                                                            disabled={!zoneData?.zoneAccess}
                                                                            color={zoneData?.zoneAccess ? 'primary' : 'secondary'}
                                                                            onChange={(e: any) => onChangeZonePermission(e, value?.locationDTO?.locationId, zoneData?.zoneDTO?.id, REPORT_PERMISSION_TYPE.SUSTAINABILITY, true)}
                                                                        />
                                                                        {t("report.sustainability")}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </ListItem>
                                                        <ListItem>
                                                            <div className="defult_form accordian_check">
                                                                <div className="form_col checkbox">
                                                                    <label>
                                                                        <Checkbox
                                                                            id={zoneData?.zoneDTO?.id}
                                                                            checked={handlePermissionStatus(zoneData?.reportPermissions, REPORT_PERMISSION_TYPE.HOST_REVENUE)}
                                                                            disabled={!zoneData?.zoneAccess}
                                                                            color={zoneData?.zoneAccess ? 'primary' : 'secondary'}
                                                                            onChange={(e: any) => onChangeZonePermission(e, value?.locationDTO?.locationId, zoneData?.zoneDTO?.id, REPORT_PERMISSION_TYPE.HOST_REVENUE, true)}
                                                                        />
                                                                        {t("report.hostrevenue")}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </ListItem>
                                                        <ListItem>
                                                            <div className="defult_form accordian_check">
                                                                <div className="form_col checkbox">
                                                                    <label>
                                                                        <Checkbox
                                                                            id={zoneData?.zoneDTO?.id}
                                                                            checked={handlePermissionStatus(zoneData?.reportPermissions, REPORT_PERMISSION_TYPE.STATION_USAGE)}
                                                                            disabled={!zoneData?.zoneAccess}
                                                                            color={zoneData?.zoneAccess ? 'primary' : 'secondary'}
                                                                            onChange={(e: any) => onChangeZonePermission(e, value?.locationDTO?.locationId, zoneData?.zoneDTO?.id, REPORT_PERMISSION_TYPE.STATION_USAGE, true)}
                                                                        />
                                                                        {t("report.stationusage")}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </ListItem>
                                                        <ListItem>
                                                            <div className="defult_form accordian_check">
                                                                <div className="form_col checkbox">
                                                                    <label>
                                                                        <Checkbox
                                                                            id={zoneData?.zoneDTO?.id}
                                                                            checked={handlePermissionStatus(zoneData?.reportPermissions, REPORT_PERMISSION_TYPE.CHARGING_SESSIONS)}
                                                                            disabled={!zoneData?.zoneAccess}
                                                                            color={zoneData?.zoneAccess ? 'primary' : 'secondary'}
                                                                            onChange={(e: any) => onChangeZonePermission(e, value?.locationDTO?.locationId, zoneData?.zoneDTO?.id, REPORT_PERMISSION_TYPE.CHARGING_SESSIONS, true)}
                                                                        />
                                                                        {t("report.chargingsessions")}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </ListItem>
                                                        {isFleetSubscribed &&
                                                            <ListItem>
                                                                <div className="defult_form accordian_check">
                                                                    <div className="form_col checkbox">
                                                                        <label>
                                                                            <Checkbox
                                                                                id={zoneData?.zoneDTO?.id}
                                                                                checked={handlePermissionStatus(zoneData?.reportPermissions, REPORT_PERMISSION_TYPE.FLEET_REPORT)}
                                                                                disabled={!zoneData?.zoneAccess}
                                                                                color={zoneData?.zoneAccess ? 'primary' : 'secondary'}
                                                                                onChange={(e: any) => onChangeZonePermission(e, value?.locationDTO?.locationId, zoneData?.zoneDTO?.id, REPORT_PERMISSION_TYPE.FLEET_REPORT, true)}
                                                                            />
                                                                            {t("report.fleet")}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </ListItem>
                                                        }
                                                    </List>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    ))}
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </InfiniteScroll>
                </div>
            </div>
        </>
    );
};

export default EditLocationPermissionListing;
